import type { IPartyColors } from './IPartyColors';

/** Відтінки типів календаря партії в порядку типів (прототип v4 pcal HUE: 13 відтінків, далі по колу). */
export const PARTY_HUES: readonly number[] = [262, 150, 25, 85, 300, 200, 330, 120, 50, 230, 10, 175, 280];

/** Відтінок типу за його місцем серед типів календаря (і без подій). Чиста функція. */
export function partyHue(index: number): number {
  return PARTY_HUES[index % PARTY_HUES.length] ?? PARTY_HUES[0]!;
}

/** Кольори типу за відтінком: крапка й ліва рамка — oklch(0.6 0.15 h), фон — oklch(0.95 0.05 h), текст — oklch(0.38 0.13 h). Чиста функція. */
export function partyColors(hue: number): IPartyColors {
  return { dot: `oklch(0.6 0.15 ${hue})`, bg: `oklch(0.95 0.05 ${hue})`, fg: `oklch(0.38 0.13 ${hue})` };
}
